import React from 'react';

function SocialMediaHero() {
  const handleQuoteClick = (e) => {
    e.preventDefault();
    const formEl = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="seo-hero-section">
      {/* Subtle background glow */}
      <div className="seo-hero-bg-glow"></div>

      <div className="container seo-hero-container">
        <div className="seo-hero-grid">
          {/* Left Column: Title, Description & 2 Buttons */}
          <div className="seo-hero-left">
            <h1 className="seo-hero-title">
              <span className="seo-red-title">Social Media Marketing In Pakistan</span> To Elevate Your Brand!
            </h1>

            <p className="seo-hero-desc">
              Ready to turn followers into loyal brand advocates and clicks into tangible revenue? As a premier social media marketing agency in Pakistan, we craft high-impact campaigns across Facebook, Instagram, LinkedIn, TikTok, and YouTube. We don't just post content; we formulate data-driven social strategies, create thumb-stopping creatives, target high-intent audiences, and deliver explosive ROI. Stop being invisible in the social feed—partner with Experts Communication to dominate your market!
            </p>

            <div className="seo-hero-btn-group">
              <a href="tel:+923177770002" className="btn-seo-call">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className="btn-seo-icon">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                <span>Call Us</span>
              </a>

              <button className="btn-seo-quote" onClick={handleQuoteClick}>
                <span>Get Free Quote</span>
              </button>
            </div>
          </div>

          {/* Right Column: Social Media Graphic Image */}
          <div className="seo-hero-right">
            <div className="seo-hero-img-wrapper">
              <img 
                src="/assets/images/social-media/social-img1.png" 
                alt="Social Media Marketing In Pakistan To Elevate Your Brand" 
                className="seo-hero-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SocialMediaHero;
